import { h } from 'preact';
import Image from '../utils/image';

const GiftWrapMessage = ({ data }) => (<div className='bg-cream-grey rounded-sm mb-2 py-3.5 px-2.5 flex items-center gap-3 laptop:gap-3.5 mx-5 laptop:mx-0'>
  {data.image && <Image
    src={data.image}
    classes=""
  />}
  {data.text && <p className='text-black utility-2 font-medium'>{data.text}</p>}
</div>)

export default GiftWrapMessage